module.exports = __webpack_public_path__ + "img/bg.ae56f794.png";